import { ProductMapper } from "@omni/mappers/product/product.mapper";
import { AlgoliaSearchAutocompleteProduct } from "@omni/types/api/search/algolia/product/autocompleteProduct.model";
import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import { ControlsPosition } from "@omni/types/components/props/productSlider.props";
import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { ProductSliderDefault } from "@/components/Product/ProductSlider/productSlider.default";
import { useResults } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import {
    PRODUCT_COUNT,
    PRODUCTS_SOURCE_ID
} from "@/components/Search/SearchBar/config/searchBar.config";
import { SearchHitContextProvider } from "@/components/Search/SearchResults/components/results/components/resultList/context/searchHit.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Items = ({ className, children }: Props) => {
    const { items } = useResults(PRODUCTS_SOURCE_ID);

    const Wrapper = ({
        item,
        children
    }: {
        item?: AlgoliaSearchAutocompleteProduct;
        children: ReactNode;
    }) => {
        return (
            <li
                key={item?.sku}
                className={cn("tw:min-w-0")}
            >
                <SearchHitContextProvider
                    queryID={item?._queryID}
                    position={item?._position}
                >
                    {children}
                </SearchHitContextProvider>
            </li>
        );
    };

    return (
        <>
            <div
                className={cn(
                    "tw:[&_.productTile]:pb-4 tw:lg:hidden",
                    className
                )}
            >
                <ProductSliderDefault
                    title={""}
                    controlsPosition={ControlsPosition.Default}
                    source={ProductSliderSources.Controlled}
                    productTileConfig={{
                        showButton: false,
                        showCategoryLink: false,
                        useInsidePadding: false,
                        amountOfFeatures: 0,
                        allowInstantAddToCart: false
                    }}
                    products={items.map(
                        ProductMapper.fromAlgoliaSearchAutocompleteToProductTile
                    )}
                    breakpointsConfig={{
                        layoutSettings: {
                            xs: { slidesPerGroup: 2.0, slidesPerView: 2.2 },
                            sm: { slidesPerGroup: 2.0, slidesPerView: 2.2 },
                            md: { slidesPerGroup: 3.0, slidesPerView: 3.0 },
                            lg: { slidesPerGroup: 4.0, slidesPerView: 4.0 },
                            xl: { slidesPerGroup: 6.0, slidesPerView: 6.0 }
                        },
                        hidden: []
                    }}
                />
            </div>
            <ul
                className={cn(
                    "tw:hidden tw:w-full tw:gap-4 tw:overflow-visible tw:grid-cols-3 tw:mb-0",
                    "tw:lg:grid",
                    className
                )}
            >
                <Mapped
                    array={items.slice(0, PRODUCT_COUNT)}
                    Wrapper={Wrapper}
                >
                    {children}
                </Mapped>
            </ul>
        </>
    );
};
